import React, { useCallback } from 'react';
import classnames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { LAYOUT_MODE_TYPES } from "../constants/layout";
import { changeLayoutMode } from 'slices/layouts/thunk';

interface LightDarkProps {
  className?: string;
}

// Single light/dark toggle used everywhere (platform header, auth/registration cards).
const LightDark = ({ className = 'ms-1 header-item d-none d-sm-flex' }: LightDarkProps) => {
  const dispatch: any = useDispatch();
  const layoutMode = useSelector((state: any) => state.Layout.layoutModeType);
  const isDark = layoutMode === LAYOUT_MODE_TYPES.DARKMODE;

  const handleToggle = useCallback(() => {
    const nextMode = isDark
      ? LAYOUT_MODE_TYPES.LIGHTMODE
      : LAYOUT_MODE_TYPES.DARKMODE;

    const root = document.documentElement;

    root.classList.add('disable-theme-transitions');
    root.setAttribute('data-bs-theme', nextMode);

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        root.classList.remove('disable-theme-transitions');
      });
    });

    dispatch(changeLayoutMode(nextMode));
  }, [dispatch, isDark]);

  return (
    <div className={className}>
      <button
        onClick={handleToggle}
        type="button"
        className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle light-dark-mode"
      >
        <i
          className={classnames(
            'fa-light fa-xl',
            isDark ? 'fa-sun-bright text-warning' : 'fa-moon text-body'
          )}
        />
      </button>
    </div>
  );
};

export default LightDark;
